import apiClient from "../../../api/core/apiClient";
import { TemplateHistoryFilters, TemplateHistoryResponse } from "../types/template-history.types";

export const getTemplateHistory = async (filters: TemplateHistoryFilters): Promise<TemplateHistoryResponse> => {
    return apiClient.get<TemplateHistoryResponse>('/crm/template-history', filters);
};
